"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const ProviderInfoListBoxLoading = ({ title, id, message = null, numColumns = 1, truncateAt = Infinity }) => {
    // build skeleton cells based on truncateAt and cols
    const cells = [];
    const itemsPerCol = Math.ceil(truncateAt / numColumns);
    for (let i = 0; i < numColumns; i++) {
        const col = [];
        for (let j = 0; j < itemsPerCol; j++) {
            col.push(react_1.default.createElement(styles_1.ShimmerText, null));
        }
        cells.push(col);
    }
    return (react_1.default.createElement(styles_1.Container, { "data-testid": `ProviderInfoListBoxLoading-${id}` },
        react_1.default.createElement(styles_1.ColContainerHeader, null,
            react_1.default.createElement(styles_1.Col, null,
                react_1.default.createElement(styles_1.Title, null, title || react_1.default.createElement(styles_1.ShimmerText, null))),
            react_1.default.createElement(styles_1.Col, null)),
        message ? message : null,
        react_1.default.createElement(styles_1.ColContainer, { className: "contracted" }, cells.map((col, colIndex) => (react_1.default.createElement(styles_1.Col, { key: colIndex },
            react_1.default.createElement(styles_1.ItemList, null, col.map((item, itemIndex) => (react_1.default.createElement(styles_1.Item, { key: itemIndex }, item)))))))),
        react_1.default.createElement(styles_1.ShowMoreButtonContainer, null,
            react_1.default.createElement(styles_1.ShimmerText, null))));
};
exports.default = ProviderInfoListBoxLoading;
//# sourceMappingURL=ProviderInfoListBoxLoading.js.map